/* @flow */
import React from 'react';
import Group from 'entities/Group';
import GroupAvatar from 'groups/components/GroupAvatar.jsx';
import Link from 'components/Link.jsx';

import './styles/ClassCardView.scss';

export class ClassCardView extends React.Component {
  static propTypes = {
    group: React.PropTypes.oneOfType([
      React.PropTypes.instanceOf(Group),
    ]).isRequired,
  };

  render() {
    const { group } = this.props;
    return (
      <Link
        className="ClassCardView"
        to={group.webUrl()}
        eventElementName="ClassCardView">
        <div
          className="ClassCardView-header"
          style={{ background: group.getAccentColor(), boxShadow: `0px 0px 0px 1px ${group.getAccentColor()}` }}>
          <GroupAvatar
            className="ClassCardView-header-avatar"
            group={group}
            size="medium"
          />
        </div>
        <div className="ClassCardView-body">
          <div className="ClassCardView-body-title">
            {group.getName()}
          </div>
          <div className="ClassCardView-body-memberCount">
            {group.getMembershipCountText()}
          </div>
        </div>
      </Link>
    );
  }
}

export default ClassCardView;



// WEBPACK FOOTER //
// ./src/settings/components/ClassCardView.jsx